/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DataTypeCategory = {
    Undefined: 'Undefined',
    Enumeration: 'Enumeration',
    Quantity: 'Quantity'
} as const;
export type DataTypeCategory = typeof DataTypeCategory[keyof typeof DataTypeCategory];


export function DataTypeCategoryFromJSON(json: any): DataTypeCategory {
    return DataTypeCategoryFromJSONTyped(json, false);
}

export function DataTypeCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataTypeCategory {
    return json as DataTypeCategory;
}

export function DataTypeCategoryToJSON(value?: DataTypeCategory | null): any {
    return value as any;
}

/**
 * Check if a given object implements the DataTypeCategory interface.
 */
 export function instanceOfDataTypeCategory(value: any): value is DataTypeCategory {
    return Object.values(DataTypeCategory).includes(value)
}

